const TRASHIE_DOCUMENT_TITLE = 'Trashie';
const TRASHIE_FAVICON = 'favicon-trashie.png';

const FORDAYS_DOCUMENT_TITLE = 'Fordays - Closet App';
const FORDAYS_FAVICON = 'favicon.webp';

// TODO - Make these configurable per env
const TRASHIE_GA_TAG_ID = {
  STAGING: 'G-TFCNJWNSPW',
  PRODUCTION: 'G-JJHCBQLQ4R',
};

const TRASHIE_GA_CONTAINER_ID = 'GTM-M76DFFST';

const TRASHIE_GOOGLE_MAPS_API_KEY = 'AIzaSyCwiD9xWf_fShyNcvMf7VFwfGK2pOEfuhY';

const TRASHIE_POSTHOG_API_KEY = {
  STAGING: 'phc_tCUfib7HsWpwrzmqTE9kmuPmsagpRTf2NccosoRCTnP',
  PRODUCTION: 'phc_eudH9GJGrFDW2HKu5vE1x1XkvNcaL6Qg69yivOQ22A',
};

const TRASHIE_LOGROCKET_APP_ID = {
  STAGING: '4wlolz/trashie-qa',
  PRODUCTION: '4wlolz/trashie-production',
};

const TRASHIE_POSTHOG_API_HOST = 'https://app.posthog.com';

const POSTHOG_FEATURE_FLAGS = {
  REWARDS_V2: 'rewards-v2',
  REWARDS_V2_AB: 'rewards-v2-AB',
  MEMBERSHIP_SUBSCRIPTION: 'membership-subscription',
  FEDEX_SHIPPING_PROVIDER: 'fedex-shipping-method',
};

const POSTHOG_MEMBERSHIP_SUBSCRIPTION_VARIANTS = {
  CONTROL: 'control',
  VARIANT_A: 'variant-a',
};

const LIST_PAGE_SIZE = 12;

const LIST_SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc',
};

const PREVIEW_LIST_PAGE_SIZE = 3;
const INITIAL_PAGE = 1;

const FORDAYS_STORE_ID = '5280b4e0-5354-4e8e-9e4d-2bffee9e37f2';
const UPS_CARRIER_NAME = 'UPS';

const TRASHIE_STRIPE_PUBLIC_KEY = {
  TEST: 'pk_test_PT6Mfn9WrkKB1idh284exVR500cUMTAdlq',
  PRODUCTION: 'pk_live_7KmPLLPdD9ctQax7do4pdYTV00pna0kPM6',
};

const QUANTITY_TYPES = {
  SINGULAR: 'singular',
  PLURAL: 'plural',
};

const SLIDER_TRACK_PADDING = {
  SMALL: 'paddingSmall',
  MEDIUM: 'paddingMedium',
  NONE: 'paddingNone',
};

const TRASHIE_META_PIXEL_ID = '2303992676763441';

const TRASHIE_REDDIT_PIXEL_ID = 'a2_idwy47xn47zy';

// Magellan AI attribution - same as Webflow
const MAGELLAN_PIXEL_ID = '019c58aadeb370f8a49dcb8ee82cbc30';

const ARTSAI_PIXEL_ID = '89979799-ff8f-41ce-ae8c-1b42f052aa90';

export {
  TRASHIE_DOCUMENT_TITLE,
  TRASHIE_FAVICON,
  FORDAYS_DOCUMENT_TITLE,
  FORDAYS_FAVICON,
  TRASHIE_GA_TAG_ID,
  TRASHIE_GOOGLE_MAPS_API_KEY,
  TRASHIE_POSTHOG_API_KEY,
  TRASHIE_POSTHOG_API_HOST,
  TRASHIE_LOGROCKET_APP_ID,
  LIST_PAGE_SIZE,
  LIST_SORT_DIRECTION,
  PREVIEW_LIST_PAGE_SIZE,
  INITIAL_PAGE,
  FORDAYS_STORE_ID,
  UPS_CARRIER_NAME,
  TRASHIE_GA_CONTAINER_ID,
  TRASHIE_STRIPE_PUBLIC_KEY,
  POSTHOG_FEATURE_FLAGS,
  POSTHOG_MEMBERSHIP_SUBSCRIPTION_VARIANTS,
  QUANTITY_TYPES,
  SLIDER_TRACK_PADDING,
  TRASHIE_META_PIXEL_ID,
  TRASHIE_REDDIT_PIXEL_ID,
  MAGELLAN_PIXEL_ID,
  ARTSAI_PIXEL_ID,
};
